import * as React from 'react';
import { Solution } from '../Enum/Solution';
import { BeltScalesNav } from './SolutionNavigation/BeltScalesNav';
import { SolutionNavigationProps } from './SolutionNavigation/SolutionNavigationProps';
import { TelemetryNav } from './SolutionNavigation/TelemetrySystemsNav';
import { TensionControlNav } from './SolutionNavigation/TensionControlNav';
import { WebGuidingNav } from './SolutionNavigation/WebGuidingNav';

interface SolutionNavProps extends SolutionNavigationProps {
    solution: Solution
}

export class SolutionSubNav extends React.Component<SolutionNavProps, {}> {
    public render() {
        switch (this.props.solution) {
            case Solution.TensionControl:
                return <TensionControlNav {...this.props}/>;
            case Solution.WebGuiding:
                return <WebGuidingNav {...this.props}/>;
            case Solution.Telemetry:
                return <TelemetryNav {...this.props}/>;
            case Solution.BeltScale:
                return <BeltScalesNav {...this.props}/>;
        }
    }
}
